/**
 * Created by vladislav on 13.08.2019
 */

cleverapps.overrideStyles(cleverapps.styles.GoalColorCellView, {
    animation: false
});
